import axios from 'axios';
import {
  SET_USERS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_ERRORS,
  SET_SNACK,
  UPDATE_USERS,
  UPDATE_USERS_STATUS,
  UPDATE_USERS_ORDERING,
} from '../types';
import i18n from '../../i18n/config';

export const getUsers =
  (buildingId, sortNameOrder = '') =>
  async (dispatch) => {
    try {
      dispatch({ type: LOADING_UI });
      const source = axios.CancelToken.source();
      let res;
      if (buildingId) {
        res = await axios.get(
          `/users?building_id=${buildingId}&sort=${sortNameOrder}name`,
          {
            cancelToken: source.token,
          }
        );
      } else {
        res = await axios.get(`/users?sort=${sortNameOrder}name`, {
          cancelToken: source.token,
        });
      }
      dispatch({ type: SET_USERS, payload: res.data?.data });
      dispatch({ type: CLEAR_ERRORS });
    } catch (err) {
      if (axios.isCancel(err) || err.message === 'Request aborted') {
        return console.log('Request canceled:', err.message); // Log if the request was canceled
      }
      const errors = err?.response?.data?.data;
      dispatch({ type: SET_ERRORS, payload: errors?.errors });
      const snackBar = {
        isOpen: true,
        text: errors?.message,
        severity: 'error',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
    }
  };

export const getAdminUsers =
  (companyId, buildingId, sortNameOrder = '') =>
  async (dispatch) => {
    try {
      dispatch({ type: LOADING_UI });
      let res;
      if (buildingId) {
        res = await axios.get(
          `/users?company_id=${companyId}&building_id=${buildingId}&sort=${sortNameOrder}name`
        );
      } else {
        res = await axios.get(
          `/users?company_id=${companyId}&sort=${sortNameOrder}name`
        );
      }
      dispatch({ type: SET_USERS, payload: res.data?.data });
      dispatch({ type: CLEAR_ERRORS });
    } catch (err) {
      const errors = err?.response?.data?.data;
      dispatch({ type: SET_ERRORS, payload: errors?.errors });
      const snackBar = {
        isOpen: true,
        text: errors?.message,
        severity: 'error',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
    }
  };

export const updateUsersOrdering = (orderBy, order) => async (dispatch) => {
  dispatch({ type: LOADING_UI });
  dispatch({ type: UPDATE_USERS_ORDERING, payload: { orderBy, order } });
  dispatch({ type: CLEAR_ERRORS });
};

export const enableDisableUsers =
  ({ status, userId }) =>
  async (dispatch) => {
    try {
      dispatch({ type: LOADING_UI });
      const type = status === '1' ? 'enable' : 'disable';
      await axios.post(`/user/action/${type}/${userId}`);
      const data = {
        status,
        userId,
      };
      dispatch({ type: UPDATE_USERS_STATUS, payload: data });
      dispatch({ type: CLEAR_ERRORS });
      const currentLanguage = i18n.language;
      const snackBar = {
        isOpen: true,
        text:
          currentLanguage === 'en'
            ? 'User Updated!'
            : 'Utilisateur mis à jour !',
        severity: 'success',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
    } catch (err) {
      console.log('err', err);
      const errors = err?.response?.data?.data;
      dispatch({ type: SET_ERRORS, payload: errors?.errors });
      const snackBar = {
        isOpen: true,
        text: errors?.message,
        severity: 'error',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
    }
  };

export const updateUsers =
  ({ data, userId, navigate }) =>
  async (dispatch) => {
    try {
      dispatch({ type: LOADING_UI });
      const { id, email, status, ...newData } = data;

      await axios.post(`/user/update/${userId}`, newData);
      dispatch({ type: UPDATE_USERS, payload: data });
      dispatch({ type: CLEAR_ERRORS });
      const currentLanguage = i18n.language;
      const snackBar = {
        isOpen: true,
        text:
          currentLanguage === 'en'
            ? 'User Updated!'
            : 'Utilisateur mis à jour !',
        severity: 'success',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
      navigate('/users');
    } catch (err) {
      const errors = err?.response?.data?.data;
      dispatch({ type: SET_ERRORS, payload: errors?.errors });
      const snackBar = {
        isOpen: true,
        text: errors?.message,
        severity: 'error',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
    }
  };

export const changeUserPin =
  ({ userId, handleClose }) =>
  async (dispatch) => {
    try {
      dispatch({ type: LOADING_UI });
      await axios.post(`/user/generate/pin/${userId}`);
      dispatch({ type: CLEAR_ERRORS });
      const currentLanguage = i18n.language;
      const snackBar = {
        isOpen: true,
        text: currentLanguage === 'en' ? 'Pin Updated!' : 'Pin mis à jour !',
        severity: 'success',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
      handleClose();
    } catch (err) {
      const errors = err?.response?.data?.data;
      dispatch({ type: SET_ERRORS, payload: errors?.errors });
      const snackBar = {
        isOpen: true,
        text: errors?.message,
        severity: 'error',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
    }
  };

export const PermaDeleteUserAccount =
  ({ userId, companyId, buildingId, handleClose }) =>
  async (dispatch) => {
    try {
      dispatch({ type: LOADING_UI });
      await axios.post(`/user/destroy/${userId}`);
      dispatch({ type: CLEAR_ERRORS });
      const currentLanguage = i18n.language;
      const snackBar = {
        isOpen: true,
        text: currentLanguage === 'en' ? 'Account Deleted!' : 'Compte supprimé',
        severity: 'success',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
      dispatch(getAdminUsers(companyId, buildingId));
      handleClose();
    } catch (err) {
      const errors = err?.response?.data?.data;
      dispatch({ type: SET_ERRORS, payload: errors?.errors });
      const snackBar = {
        isOpen: true,
        text: errors?.message,
        severity: 'error',
      };
      dispatch({ type: SET_SNACK, payload: snackBar });
    }
  };
